import { createContext } from 'react';
import { IFullTipSchema } from 'shared/repositories/text-search/entities/tips/FullTipSchema';
import { IFullTipV2Schema } from 'shared/repositories/text-search/entities/tips/FullTipV2Schema';

export type TipsContextProps = {
  mainTips: IFullTipSchema[];
  searchTips: IFullTipSchema[];
  mobileTips: IFullTipV2Schema[];
  clickedTip: IFullTipSchema | null;
  isTipsDisabled: boolean;

  loadMainTips: (query?: string) => Promise<void>;
  loadSearchTips: (query: string) => Promise<void>;
  loadMobileTips: (query: string) => Promise<void>;
  handleMainTipClick: (tip: IFullTipSchema) => void;
};

export const TipsContext = createContext<TipsContextProps | undefined>(undefined);
